import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  > *:last-child {\n    margin: 0;\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    display: none;\n  }\n  @media screen and (max-width: ", "px) {\n    display: block;\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    right: 6px;\n\n    ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (max-width: ", "px) {\n    display: flex;\n    justify-content: center;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n\n  > h2 {\n    margin: 0;\n    font-size: 14px;\n    line-height: 22px;\n  }\n  @media screen and (max-width: ", "px) {\n    width: 100%;\n    text-align: center;\n    > h2 {\n      font-size: 12px;\n      line-height: 16px;\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0 0 0 8px;\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n  @media screen and (max-width: ", "px) {\n    font-size: 12px;\n    line-height: 16px;\n    padding-top: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 27px;\n  margin: 0;\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n    text-align: center;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 16px;\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    left: 20px;\n    position: absolute;\n\n    ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    width: 100%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: ", "px;\n  padding: 0 60px;\n  box-sizing: content-box;\n\n  @media screen and (max-width: ", "px) {\n    flex-wrap: wrap;\n    padding: 0 30px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n    padding: 0 20px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 104px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 80px;\n  width: 100%;\n\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    ", "\n    top: 69px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  animation-fill-mode: forwards;\n  animation: ", " 200ms ease-in-out;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(-56px);\n  }\n  to {\n    transform: translateY(0);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 64px;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { ActionButton } from '../ActionButton';
import { BackButton } from '../BackButton';
import { SettingsButton } from '../SettingsButton';
import { SavedLabel } from '../SavedLabel';
import styled, { css, keyframes } from '../utils/styling/styled-components';
import { ACTION_STRIP } from '../utils/testing/TestIDs';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { enhance } from './enhance';
import { InvertedStrip } from './InvertedStrip';
var Container = styled.div(_templateObject(), function (props) {
  return props.collapse && "\n    @media screen and (max-width: ".concat(props.theme.breakpoints.md, "px) {\n      height: 0;\n    }\n  ");
});
var slideDown = keyframes(_templateObject2());
var slideDownAnimation = css(_templateObject3(), slideDown);
var Content = styled.div(_templateObject4(), function (props) {
  return props.sticky && "\n    background-color: rgba(245,245,245,".concat(props.scrollPercent, ");\n    border-top: 1px solid rgba(240, 240, 240, ").concat(props.scrollPercent, ");\n    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, ").concat(props.scrollPercent * 0.05, ");\n    height: ").concat(104 - (104 - props.stickyHeight) * props.scrollPercent, "px;\n    position: fixed;\n    z-index: 20;\n  ");
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.sticky && slideDownAnimation;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return !props.sticky && "\n      height: 80px;\n      top: 72px\n    ";
});
var Constrainer = styled.div(_templateObject5(), function (props) {
  return props.maxWidth;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.customStyle ? props.customStyle : 'flex-wrap: wrap';
});
var TitleContainer = styled.div(_templateObject6(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.sticky && "\n      width: 100%;\n    ";
}, function (props) {
  return props.theme.breakpoints.sm;
});
var BackButtonStyled = styled(BackButton)(_templateObject7(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.sticky && "\n      background-color: transparent;\n      box-shadow: none;\n      left: 16px;\n      position: absolute;\n    ";
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.sticky && "\n      left: 6px;\n    ";
});
var Title = styled.h1(_templateObject8(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.sticky && "\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 27px;\n      text-align: center;\n    ";
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.customTitleStyle ? props.customTitleStyle : 'padding-left: 0';
});
var Subtitle = styled.h2(_templateObject9(), function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.sticky && "\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 27px;\n      margin: 0 0 0 4px;\n      text-align: center;\n      padding-top: 6px;\n      white-space: nowrap;\n    ";
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.sticky ? '6px' : '8px';
}, function (props) {
  return props.customSubtextStyle && props.customSubtextStyle;
});
var VerticalSubTextContainer = styled.div(_templateObject10(), function (props) {
  return props.theme.breakpoints.sm;
});
var HorizontalSubtextContainer = styled.div(_templateObject11(), function (props) {
  return props.theme.breakpoints.sm;
});
var SettingsButtonStyled = styled(SettingsButton)(_templateObject12(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.sticky && "\n    background-color: transparent;\n    box-shadow: none;\n    right: 16px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    ";
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.sticky && "\n      right: 6px;\n    ";
});
var ActionContainer = styled.div(_templateObject13(), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.customStyle ? props.customStyle : 'display: none';
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return (props.sticky || props.showInverted) && "\n      display: none;\n    ";
});
var ActionStrip = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Container, {
    collapse: props.collapse || props.showInverted,
    "data-testid": ACTION_STRIP,
    className: props.className
  }, props.showInverted && /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: props.theme.breakpoints.md
  }, /*#__PURE__*/React.createElement(InvertedStrip, {
    onBackPress: props.onBackPress,
    showBack: props.showBack,
    subtext: props.subtext,
    title: props.showResponsiveTitle ? props.title : null,
    children: props.children
  })), /*#__PURE__*/React.createElement(Content, {
    scrollPercent: props.scrollPercent,
    sticky: props.sticky,
    stickyHeight: props.stickyHeight
  }, /*#__PURE__*/React.createElement(Constrainer, {
    maxWidth: props.maxWidth,
    customStyle: props.customStyle
  }, /*#__PURE__*/React.createElement(TitleContainer, {
    sticky: props.sticky
  }, props.hasBack && props.showBack && /*#__PURE__*/React.createElement(BackButtonStyled, {
    onClick: props.onBackPress,
    sticky: props.sticky
  }), props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubTextContainer, null, props.title && /*#__PURE__*/React.createElement(Title, {
    customTitleStyle: props.customTitleStyle,
    sticky: props.sticky
  }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
    sticky: props.sticky,
    customSubtextStyle: props.customSubtextStyle
  }, props.subtext)) : /*#__PURE__*/React.createElement(HorizontalSubtextContainer, null, props.title && /*#__PURE__*/React.createElement(Title, {
    customTitleStyle: props.customTitleStyle,
    sticky: props.sticky
  }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
    sticky: props.sticky,
    customSubtextStyle: props.customSubtextStyle
  }, props.subtext)), props.hasStickySettings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Go to settings"), /*#__PURE__*/React.createElement(SettingsButtonStyled, {
    sticky: props.sticky,
    onClick: props.onSettingsPress
  })), props.savedLabel && /*#__PURE__*/React.createElement(SavedLabel, {
    show: props.savedLabel.saved,
    text: props.savedLabel.text
  })), /*#__PURE__*/React.createElement(ActionContainer, {
    customStyle: props.customStyle,
    sticky: props.sticky,
    showInverted: props.showInverted
  }, props.actions && props.actions.map(function (action) {
    return /*#__PURE__*/React.createElement(ActionButton, {
      key: action.id,
      icon: action.icon,
      text: action.text,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }), props.children))));
});
export { ActionStrip };